var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column main-layout"},[_c('the-header'),_c('router-view',{staticClass:"flex-grow-1"}),_c('the-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }